import React from 'react';
import classNames from 'classnames';
import generateClassModifiers from '../../helpers/generate-class-modifiers';
import { ALIGN, VERTICAL_ALIGN } from './constants';
const HorizontalStack = ({
  children,
  gap = 'spacing-4-xs',
  rowGap = 'spacing-4-xs',
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '{ xs?: { ga... Remove this comment to see the full error message
  breakpoints = null,
  wrap = false,
  align = ALIGN.left,
  verticalAlign = VERTICAL_ALIGN.stretch,
}) => {
  const spaceClass = generateClassModifiers('ws-ui-horizontal-stack', { gap });
  const rowSpaceClass = generateClassModifiers('ws-ui-horizontal-stack', { rowGap });
  const breakpointsSpacesClasses =
    breakpoints &&
    Object.keys(breakpoints).map((key) =>
      generateClassModifiers('ws-ui-horizontal-stack', breakpoints[key], key)
    );

  const classes = classNames(
    'ws-ui-horizontal-stack',
    `ws-ui-horizontal-stack--align-${align}`,
    `ws-ui-horizontal-stack--vertical-align-${verticalAlign}`,
    spaceClass,
    rowSpaceClass,
    breakpointsSpacesClasses,
    {
      'ws-ui-horizontal-stack--wrap': wrap,
    }
  );
  return <div className={classes}>{children}</div>;
};

export default HorizontalStack;
